module.exports = __webpack_public_path__ + "img/C03TechConfusion_ua.ddc2faa0.webp";